/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Container = styled.button`
  width: 448px;
  height: 48px;
  background: #0b29fb;
  border: 1px solid #0b29fb;
  border-radius: 4px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  outline: none !important;
  transition: all 0.2s;
  padding: 16px;

  &:active {
    filter: brightness(0.9);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  ${({ buttonType }) =>
    buttonType === 'disabled' &&
    css`
      background: #e8ecf1;
      border: 1px solid #e8ecf1;
      color: #b6b3b3;
    `}

  ${({ buttonType }) =>
    buttonType === 'outline' &&
    css`
      background: #ffff;
      border: 1px solid #0b29fb;
      color: #0b29fb;
    `}

  svg {
    float: ${({ float }) => float};
    margin-bottom: -2px;
  }
`;
